module.exports = __webpack_public_path__ + "img/relax1.5e4f6664.png";